import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { message } from 'antd';
import { HttpStatusCode } from '@/fetch/core/constant';
import { actionSendHttpRequest } from '@/redux/action';
import { RootState } from '@/redux/store';

interface UserAuthHook {
  getUserInfo: (cb?: Function) => void;
  hasVehiclePermission: boolean;
  hasPDAPermission: boolean;
}

export const useUserAuth = (): UserAuthHook => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const login = useSelector((state: RootState) => state.login);

  const getUserInfo = (cb?: Function) => {
    const loginData = {
      method: 'POST',
      path: '/authentication/getLoginUserInfo',
      body: {
        appCode: 'rover-auto-monitor-ui',
      },
      actionType: 'USER_INFO',
      nextActionFunc: (resp: any) => {
        if (resp.code != HttpStatusCode.Success) {
          message.error('登录过期，请重新登录');
          navigate('/login');
        } else {
          const hasVehiclePermission = 
            resp.data.resourceList?.findIndex(
              (item: any) => item.code === 'spv_realtime'
            ) > -1;
          const hasPDAPermission = 
            resp.data.resourceList?.findIndex(
              (item: any) => item.code === 'spv_pda_page'
            ) > -1;
          
          if (!hasVehiclePermission && !hasPDAPermission && 
              window.location.pathname !== '/app/403') {
            window.location.href = '/app/403';
            return;
          }
          cb?.();
        }
      },
    };
    dispatch(actionSendHttpRequest(loginData));
  };

  useEffect(() => {
    getUserInfo();
  }, []);

  return {
    getUserInfo,
    hasVehiclePermission: login.resourceList?.some(
      (item: any) => item.code === 'spv_realtime'
    ),
    hasPDAPermission: login.resourceList?.some(
      (item: any) => item.code === 'spv_pda_page'
    ),
  };
};
